import React from 'react';

const TextArea = ({
  label,
  value,
  name,
  className,
  error,
  validate,
  helpText,
  classsName = 'col-sm-12',
  labelClassName = 'col-sm-4',
  controlClassName = 'col-sm-8',
  onChange
}) => (
  <div className={classsName}>
    <div className={`form-group row ${error.length > 0 && 'has-error'}`}>
      <label className={`${labelClassName} col-form-label`}>{label}</label>
      <div className={controlClassName}>
        <textarea
          value={value}
          name={name}
          onChange={onChange}
          className={`textarea ${className} ${error.length > 0 && 'is-danger'}`}
          onBlur={validate}
        />
        <span className="form-text m-b-none">{helpText}</span>
        {error.map((obj, index) => (
          <span className="form-text m-b-none text-error" key={index}>
            {obj}
          </span>
        ))}
      </div>
    </div>
  </div>
);

export default TextArea;
